<template>
    <div class="mb-4">
        <span v-bind:key="word.uuid"
             v-for="word in preparedWords"
             class="pl-2 pb-1 mr-3 mb-3 word-pill primary-font d-inline-block">
            <span class="word-text">{{word.word}}</span>
            <button class="btn btn-link btn-remove p-0 m-0 d-inline-flex align-items-center justify-content-center"
                    v-on:click="removeWord(word.uuid)">
                <SvgIcon icon="cross" class="icon-sm icon-close" title="remove word"/>
            </button>
            <button class="btn btn-link btn-add p-0 m-0 d-inline-flex align-items-center justify-content-center"
                    v-on:click="seeMore(word)">
                <SvgIcon icon="eye" class="icon-sm icon-add" title="get related words"/>
            </button>
        </span>
    </div>
</template>

<script>
    import SvgIcon from './SvgIcon';
    import {GET_RECOMMENDATIONS} from '../store/action-types';

    export default {
        name: "WordsList",
        components: {
            SvgIcon
        },
        computed: {
            preparedWords () {
                return this.$store.state.words;
            }
        },
        methods: {
            removeWord(uuid) {
                this.$store.commit('REMOVE_WORD', {uuid: uuid});
            },
            seeMore(word) {
                this.$store.dispatch(GET_RECOMMENDATIONS, word.word.toLowerCase().trim());
            }
        }
    }
</script>

<style scoped lang="scss">
    .word-pill {
        background-color: $black;
        color: white;
        border-radius: 4px;
        position: relative;
        padding-top: .1rem;
        padding-bottom: .1rem;
        padding-right: 5rem;
    }

    .word-text {
        display: inline-block;
        padding-top: 2px;
    }

    .btn {
        position: absolute;
        height: 100%;
        width: 1.5rem;
    }

    .btn-remove {
        top: 0;
        right: .5rem;
    }

    .btn-add {
        top: 0;
        right: 2rem;
    }

    .icon-close, .icon-add {
        stroke: $primary;
    }
</style>
